<template>
  <!-- <SitePreHeader /> -->
  <SiteHeader />
  <SiteHeroBanner
  />
  <main>
    <SitePitch
      id="pitch"
      ref="pitch"
      data-hash
    />
    <SiteFeatures
      id="features"
      ref="features"
      data-hash
    />
    <SitePrice
      id="price"
      ref="price"
      data-hash
      @signup="showSignUp('price-' + $event)"
    />
    <SiteConversion
    />
    <SiteSocial
      id="feedback"
      ref="feedback"
      data-hash
    />
  </main>
  <SiteFooter
  />
  <SitePostFooter />

  <GlobalEvents
    target="window"
    @scroll="checkHashTag"
  />

  <ClientOnly>
    <BrevoConversation />
  </ClientOnly>
</template>

<script setup>
  import SitePreHeader from '@/sections/SitePreHeader'
  import SiteHeader from '@/sections/SiteHeader'
  import SiteHeroBanner from '@/sections/home/SiteHeroBanner'
  import SitePitch from '@/sections/home/SitePitch'
  import SitePrice from '@/sections/home/SitePrice'
  import SiteConversion from '@/sections/home/SiteConversion'
  import SiteSocial from '@/sections/home/SiteSocial'
  import SiteFeatures from '@/sections/home/SiteFeatures'
  import SiteFooter from '@/sections/SiteFooter'
  import SitePostFooter from '@/sections/SitePostFooter'
  import BrevoConversation from '@/components/BrevoConversation'
  import { GlobalEvents } from 'vue-global-events'
  import debounce from 'lodash.debounce'
  import useIdentity from '@/components/SiteIdentity'

  const siteIdentity = useIdentity()
  const route = useRoute()

  await siteIdentity.synchronizeAuthAndIdent(true, false)


  definePageMeta({
    name: 'landing'
  })

  // Configuration SEO pour la page d'accueil
  const { setSeoMeta } = useSeo()

  setSeoMeta({
    title: 'CRA en ligne gratuit - Compte Rendu d\'Activité Freelance | CRA Freelance',
    description: 'CRA en ligne gratuit pour freelances en régie. Générez votre Compte Rendu d\'Activité en quelques clics : signature électronique, validation par le client, export PDF. Gratuit et illimité.',
    type: 'website',
    keywords: [
      'CRA en ligne',
      'CRA en ligne gratuit',
      'CRA freelance',
      'compte rendu d\'activité',
      'compte rendu activité freelance',
      'CRA régie',
      'modèle CRA',
      'générateur CRA',
      'CRA ESN',
      'signature CRA',
      'validation CRA client',
      'CRA gratuit',
      'CRA PDF'
    ],
    faqs: [
      {
        question: 'Qu\'est-ce qu\'un CRA (Compte Rendu d\'Activité) ?',
        answer: 'Le CRA (Compte Rendu d\'Activité) est un document mensuel utilisé par les freelances en régie pour déclarer leurs jours travaillés auprès de l\'ESN ou du client final. Il sert de base à la facturation et formalise la prestation réalisée.'
      },
      {
        question: 'Comment faire un CRA en ligne gratuitement ?',
        answer: 'Avec CRA Freelance, remplissez votre calendrier mensuel en quelques clics : les jours fériés et week-ends sont pré-remplis. Signez électroniquement, envoyez au client pour validation, et exportez en PDF. C\'est gratuit et illimité.'
      },
      {
        question: 'Est-ce que CRA Freelance est vraiment gratuit ?',
        answer: 'Oui, la génération de CRA est entièrement gratuite et illimitée : signature électronique, validation client et export PDF inclus. Une offre Intégration à 4,99 €/mois est disponible pour le tableau de bord, les notifications et la connexion à vos outils de facturation (Pennylane, Indy, Tiime).'
      },
      {
        question: 'Comment fonctionne la validation du CRA par le client ?',
        answer: 'Votre client reçoit un lien par email pour consulter et valider votre CRA directement depuis son navigateur. Il peut signer électroniquement sans impression ni scan. Vous êtes notifié dès la validation.'
      },
      {
        question: 'Puis-je connecter mes CRA à Pennylane, Indy ou Tiime ?',
        answer: 'Oui, avec l\'offre Intégration, vos CRA validés sont connectés à Pennylane, Indy ou Tiime. Votre facture est générée automatiquement dans votre outil comptable à partir des données du CRA.'
      },
      {
        question: 'Faut-il créer un compte pour utiliser CRA Freelance ?',
        answer: 'Oui, un compte gratuit est nécessaire pour sauvegarder vos CRA et retrouver votre historique. La création de compte prend quelques secondes avec votre adresse email.'
      },
      {
        question: 'Quel est le meilleur outil pour faire un CRA freelance ?',
        answer: 'CRA Freelance est un outil en ligne gratuit conçu spécifiquement pour les freelances en régie. Il remplace les modèles Excel et les scans de signature par un workflow entièrement dématérialisé : calendrier, signature électronique, validation client et export PDF.'
      }
    ]
  })

  const checkHashTag = debounce(() => {
    const hashTagSections = Array.from(document.querySelectorAll('[data-hash]'))

    const tops = hashTagSections.filter((target) => {
      if (target) {
        const top = target.getBoundingClientRect().y
        const height = target.clientHeight
        const topIsPassed = top < 100
        const bottomIsNotPassed = top + height > 100
        return topIsPassed && bottomIsNotPassed
      } else {
        return false
      }
     
    })
    const [firstVisible] = tops

    if (firstVisible) {
      const newHash = `#${firstVisible.id}`
      if (location.hash !== newHash) {
        history.replaceState(null, null, document.location.pathname + newHash);
      }
    } else {
      history.replaceState(null, null, document.location.pathname);
    }
  }, 200, {
    maxWait: 200
  })

  onMounted(() => {
    const hash = route.hash
    if (hash) {
      setTimeout(() => {
        const top = document.getElementById(hash.replace('#', '')).getBoundingClientRect().y
        window.scrollTo({ top: top + window.scrollY, behavior: 'smooth' })
      }, 300)
    }
  })

</script>

<style>
html {
  font-family: 'Outfit';
  font-size: 18px;
  font-weight: 300;
}
</style>